<script type="text/javascript">
    import { http } from '../../http';

    export default {
        props: {
            practizeShell: {
                type: Boolean,
                default: false,
            },
            token: {
                required: true,
            },
            email: {
                required: true,
            },
        },

        data: () => {
            return {
                password: '',
                passwordConfirm: '',
                loading: false,
                submitLoading: false,
                showError: false,
                errorMessage: null,
            }
        },

        mounted() {
            this.$root.$on('countryUpdated', country => {
                this.$forceUpdate();
            });
        },

        methods: {
            hideMessages() {
                this.showError = false;
            },

            submitResetForm() {
                this.hideMessages();

                var data = {
                    email: this.email,
                    token: this.token,
                    password: this.password,
                    password_confirmation: this.passwordConfirm,
                }

                this.submitLoading = true;
                http.post('/password/reset', data)
                    .then(() => {
                        window.location.href = '/';
                    })
                    .catch((error) => {
                        // Errors can either be stored in the "email", "password", or "token" attributes
                        if ('email' in error.response.data) {
                            this.errorMessage = error.response.data.email.join('\n\n');
                        } else if ('password' in error.response.data) {
                            this.errorMessage = error.response.data.password.join('\n\n');
                        // This branch should never be taken
                        } else if ('token' in error.response.data) {
                            this.errorMessage = error.response.data.token.join('\n\n');
                        }
                        this.showError = true;
                        this.submitLoading = false;
                    });
            },
        }
    }
</script>

<template id="reset-form">
    <div>
    <div v-if="!practizeShell" class="logo-container"></div>

    <div :id="practizeShell ? null : 'loginFormWrapper'" :class="practizeShell ? 'practize-login-form' : 'login-form-wrapper form-wrapper'">
        <h1 v-if="practizeShell" class="form-title">{{ trans('passwords.reset_password') }}</h1>
        <div class="message-container">
            <div class="message error-message" role="alert" v-if="showError">
                <p>
                    <svg version="1.1" id="errorIcon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 47 47">
                        <g>
                            <path d="M22.8,46c-12.6-0.2-22.1-10.1-22-22.8C1,10.6,11.4,0.4,24,0.7C36.6,1,46.3,11.3,46.2,24.1C46,36.8,36,46.2,22.8,46z
                                    M23.5,40.8c10.1,0,17.4-7.2,17.4-17.2c0-10-7.4-17.6-17.2-17.7C13.7,5.8,6,13.5,6.1,23.6C6.2,33.7,13.4,40.8,23.5,40.8z"/>
                        </g>
                        <line class="st0" x1="23" y1="11" x2="23" y2="26"/>
                        <circle cx="23" cy="33" r="3"/>
                    </svg>
                    <span style="white-space: pre-line">{{ errorMessage }}</span>
                </p>
            </div>
        </div>

        <div class="message">
            <p>
                {{ trans('passwords.reset_confirmation_information', {'email': email}) }}
                <br><br>
                {{ trans('settings.profile_password_requirements', {'min': 7}) }}
            </p>
        </div>

        <form id="reset" method="POST" class="mainForm" :aria-label="trans('passwords.reset_password')" @submit.prevent="submitResetForm">
            <div :class="practizeShell ? 'field' : 'input-container'">
                <label v-if="practizeShell" for="password">{{ trans('settings.profile_password_new') }}</label>
                <input id="password" type="password" name="password" required autocomplete="new-password" :placeholder="trans('settings.profile_password_new')" v-model="password">
            </div>

            <div :class="practizeShell ? 'field' : 'input-container'">
                <label v-if="practizeShell" for="password-confirm">{{ trans('settings.profile_password_new_repeat') }}</label>
                <input id="password-confirm" type="password" name="password_confirmation" required autocomplete="new-password" :placeholder="trans('settings.profile_password_new_repeat')" v-model="passwordConfirm">
            </div>

            <button type="submit" :class="practizeShell ? 'primary-btn' : 'btn btn-primary'" :disabled="submitLoading">
                <span v-if="!submitLoading">{{ trans('passwords.reset_password') }}</span>

                <svg v-else version="1.1" id="loader-1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                         width="40px" height="40px" viewBox="0 0 50 50" style="enable-background:new 0 0 50 50;" xml:space="preserve">
                    <path fill="#000" d="M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z">
                        <animateTransform attributeType="xml"
                                          attributeName="transform"
                                          type="rotate"
                                          from="0 25 25"
                                          to="360 25 25"
                                          dur="0.6s"
                                          repeatCount="indefinite"/>
                    </path>
                </svg>
            </button>
        </form>

    </div>

    </div>
</template>